export default "__VITE_ASSET__DTE9PliC__"